/* Name actions as NOUN_VERB */

export const POST_INIT_DATA_FETCH = "POST_INIT_DATA_FETCH"
export const POST_INIT_DATA_RECEIVE = "POST_INIT_DATA_RECEIVE"
export const KEYWORD_DATA_FETCH = "KEYWORD_DATA_FETCH"
export const KEYWORD_DATA_RECEIVE = "KEYWORD_DATA_RECEIVE"

export const MODAL_OPEN = "MODAL_OPEN"
export const MODAL_CLOSE = "MODAL_CLOSE"

export const SORT_CHANGE = "SORT_CHANGE"

export const FILTER_TOGGLE = "FILTER_TOGGLE"
export const FILTER_PUSH = "FILTER_PUSH"
export const FILTER_REPLACE = "FILTER_REPLACE"
export const NESTING_TOGGLE = "NESTING_TOGGLE"
export const ALL_FILTERS_DEACTIVATE = "ALL_FILTER_DEACTIVATE"
export const FILTER_CONTEXT_DEACTIVATE = "FILTER_CONTEXT_DEACTIVATE"
export const FILTER_GROUP_DEACTIVATE = "FILTER_GROUP_DEACTIVATE"

export const KEYWORD_TEXT_CHANGE = "KEYWORD_TEXT_CHANGE"
export const KEYWORD_TEXT_SEARCH = "KEYWORD_SEARCH"
export const KEYWORD_MATCH_COMPLETE = "KEYWORD_MATCH_COMPLETE"

